// extracted by mini-css-extract-plugin
module.exports = {"oos":"Announcements_oos__vtZfm"};